export const newAnalysisDay = 4;

export type AnalyzedConsumption = {
  nettleietrinn: AnalyzeNettleie;
  price_days: AnalyzeConsumptionPrice;
  price_hours: AnalyzeConsumptionPrice;
};

export type AnalyzeNettleie = {
  result: string;
  advisory: string;
  expected_result: string; // Forventet nettleietrinn
  expected_result_cost: number; // Kostnadsdifferanse forventet trinn og nåværende trinn
  expected_cost: number; // Pris for forventet nettleietrinn
  netteier: string;
  previous_step: Step;
  current_step: Step;
  next_step: Step;
  steps: Step[];
  avg_high_three: number;
  num_below: number;
  num_above: number;
  num_current: number;
  hours_high_three: Hours[];
  hours_to_look_at: Hours[];
  hours_daymax: Hours[];
  sum_consumption: number;
};

export type AnalyzeConsumptionPrice = {
  result:
    | 'WHOHOO_YOU_ARE_DOING_GREAT'
    | 'KEEP_CALM_AND_CARRY_ON_AS_USUAL'
    | 'REDUCTION_POSSIBLE';
  advisory: string | null;
  avg_cost: number;
  real_cost: number;
  target_cost: number;
};

export type AnalyzeData = {
  period: number;
  items: AnalyzeDataItem[];
};

export type AnalyzeDataItem = {
  kwh: number;
  period: number;
  target_cost: number;
  real_cost: number;
};

export type Step = {
  step: number;
  cost: number;
  limit: number;
  next_limit: number;
  previous_limit: number;
};

export type Hours = {
  kwh: number;
  period: number;
};

export type SmartScore = {
  kunde_id: number;
  object_id: string;
  fk_date: number; // YYYYMMDD
  period: number; // YYYYMM
  price_area: string;
  consumption_code: string;
  nok_consumption_energy: number;
  nok_consumption_delivery: number;
  nok_step_delivery: number;
  state_step_delivery: number;
  state_consumption_days: number;
  state_consumption_hours: number;
  level: number;
};

export type Prediction = {
  daily: PredictionData[]; // Ukedag
  hourly: PredictionData[]; // dag, natt, kveld
  daily_hourly: {
    category: string; // Ukedag
    values: PredictionData[]; // dag, natt, kveld
  }[];
};

export type PredictionData = {
  category: string;
  value: number; // 0.0 - 1.0
};
